// extracted by mini-css-extract-plugin
export default {"download":"KHeyv__download","spinner":"j_4uz__spinner"};